import { render } from "./InputLayout.vue?vue&type=template&id=97d3504a&scoped=true&ts=true"
import script from "./InputLayout.vue?vue&type=script&lang=ts"
export * from "./InputLayout.vue?vue&type=script&lang=ts"

import "./InputLayout.vue?vue&type=style&index=0&id=97d3504a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d3504a"]])

export default __exports__